import { style, animate, trigger, state, transition} from "@angular/animations";
import { fadeInUpAnimation, fadeOutDownAnimation, fadeInAnimation } from "angular-animations";

export const mvnfbuAnimations =  [
    trigger('fadeZoom', [
      state('in', style({
        opacity: 1, transform: 'scale(1)'
      })),
      state('out', style({
        opacity: 0, transform: 'scale(0.8)'
      })),
      transition('in => out', [
        animate('500ms')
      ]),
      transition('out => in', [
        animate('750ms 250ms')
      ])
    ]),
    trigger('fadeInZoomSlowBig', [
      state('in', style({
        opacity: 1, transform: 'scale(1)'
      })),
      state('out', style({
        opacity: 0, transform: 'scale(0.2)'
      })),
      transition('out => in', [
        animate('550ms 150ms')
      ])
    ]),
    trigger('fadeInOut', [
      state('in', style({
        opacity: 1, transform: 'scale(1) translateX(0%)'
      })),
      state('out', style({
        opacity: 0, transform: 'scale(0.5) translateX(-100%)'
      })),
      transition('in => out', [
        animate('500ms')
      ]),
    ]),
    trigger('fadeOutIn', [
      state('in', style({
        opacity: 1, transform: 'scale(1) translateX(0%)'
      })),
      state('out', style({
        opacity: 0, transform: 'scale(0.5) translateX(100%)'
      })),
      transition('out => in', [
        animate('500ms')
      ]),
    ]),
    trigger('zoomSmallFull', [
      state('small', style({
        position: 'absolute',
        width: 'calc(50% - 9vw)',
        height: '50%',
        top: 'calc(10% + 2vw)',
        right: '7vw'
      })),
      state('full', style({
        position: 'absolute',
        right: '2.5vw',
        top: '10%',
        width: 'calc(100% - 5vw)',
        height: 'calc(90% - 2vw)',
        padding: '0vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      })),
      transition('small <=> full', [
        animate('1000ms ease')
      ]),
    ]),
    fadeInUpAnimation({ anchor: 'enterUpSlow', duration: 1000, delay: 250, translate: '150%' }),
    fadeOutDownAnimation({ anchor: 'leaveDownSlow', duration: 500, delay: 250, translate: '150%' }),
    fadeInUpAnimation({ anchor: 'enterUpFast', duration: 500, delay: 0, translate: '150%' }),
    fadeOutDownAnimation({ anchor: 'leaveDownFast', duration: 750, delay: 500, translate: '150%' }),
    fadeInAnimation({ anchor: 'fadeInSlow', duration: 1000, delay: 1000 }),
    fadeInAnimation({ anchor: 'fadeIn', duration: 300 }),
    fadeInAnimation({ anchor: 'fadeOut', duration: 300 })
   
  ]

